module.exports = __webpack_public_path__ + "img/coop5.f547e803.png";